import { ComponentOverrides } from "@/__configs/config_types";
import React from "react";
import { useConfigValue } from "./useConfigValue";

const useComponentOverride = <T extends object>(Component: React.ComponentType<T>, name: keyof ComponentOverrides, props: T) => {
  const Override = useConfigValue(["componentOverrides", name]);

  if (Override) {
    return <Override {...props} />;
  }

  return <Component {...props} />;
};

export default useComponentOverride;